export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_REQUEST_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_REQUEST_FAIL';
export const LOGOUT_ACTION = 'LOGOUT_ACTION';
